import React, { useState } from 'react';
import { TextField, Button, Container, Typography } from '@mui/material';

const AgentEmailInput = ({ onSurveyLinkChange }) => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const handleInputChange = (event) => {
        setEmail(event.target.value);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        await onSurveyLinkChange(email);
        setLoading(false);
    };

    return (
        <Container>
            <form onSubmit={handleSubmit}>
                <Typography variant="h5" color="primary" gutterBottom>
                    Please enter your State Farm Alias email address to access the form
                </Typography>
                <TextField
                    label="Email"
                    value={email}
                    onChange={handleInputChange}
                    fullWidth
                    margin="normal"
                    required
                    type="email"
                    placeholder='your.email.alias@statefarm.com'
                />
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{ marginTop: '20px' }}
                    loading={loading}>
                    Next
                </Button>
            </form>
        </Container>
    );
};

export default AgentEmailInput;